import { Route } from "react-router";
import { ProtectedRoute } from "./components";
import Datahub from "@/pages/support/Datahub";
import { ActiveUserList, Translation } from "@/pages";
import React from "react";
import { permissionsTranslation } from "@/utils/permissions/permissionsTranslation";
import { permissionsActiveUsers } from "@/utils/permissions/permissionsActiveUsers";
import { permissionsDeveloper } from "@/utils/permissions/permissionsDeveloper";

// const parentPath = "support"; // Unused variable

/**
 * Route definitions for support and developer utility routes.
 * Includes datahub, translation management, and active user monitoring.
 */
export const supportRoutes: React.ReactElement[] = [
  <Route
    key="datahub"
    path="datahub"
    element={
      <ProtectedRoute element={<Datahub />} codes={permissionsDeveloper} />
    }
  />,

  <Route
    key="translation"
    path="translation"
    element={
      <ProtectedRoute
        element={<Translation />}
        codes={permissionsTranslation}
      />
    }
  />,

  <Route
    key="active-users"
    path="active-users"
    element={
      <ProtectedRoute
        element={<ActiveUserList />}
        codes={permissionsActiveUsers}
      />
    }
  />,
];
